import { Tag, Tooltip } from 'antd';
import { FC } from 'react';

interface ITagItem {
  id: string | number;
  name: string;
}

interface ITruncatedTagListProps {
  items?: ITagItem[] | null;
  maxVisible?: number;
  maxTextLength?: number;
}

export const TruncatedTagList: FC<ITruncatedTagListProps> = ({
  items,
  maxVisible = 2,
  maxTextLength = 20,
}) => {
  if (!items || items.length === 0) {
    return <>-</>;
  }

  const visibleItems = items.slice(0, maxVisible);
  const hiddenItems = items.slice(maxVisible);
  const hiddenCount = hiddenItems.length;

  const truncateText = (text: string) => {
    return text.length > maxTextLength
      ? `${text.slice(0, maxTextLength)}...`
      : text;
  };

  return (
    <>
      {visibleItems.map((item) => (
        <Tooltip key={item.id} title={item.name}>
          <Tag>{truncateText(item.name)}</Tag>
        </Tooltip>
      ))}
      {hiddenCount > 0 && (
        <Tooltip title={hiddenItems.map((i) => i.name).join(', ')}>
          <Tag>+{hiddenCount}</Tag>
        </Tooltip>
      )}
    </>
  );
};
